import { render } from "./invitationError.vue?vue&type=template&id=87bb9bc6&scoped=true"
import script from "./invitationError.vue?vue&type=script&lang=js"
export * from "./invitationError.vue?vue&type=script&lang=js"

import "./invitationError.vue?vue&type=style&index=0&id=87bb9bc6&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87bb9bc6"]])

export default __exports__